export function replaceAtIndex<T>(
  array: T[] | undefined,
  index: number,
  newItem: T
): T[] {
  return array ? array.map((item, i) => (i === index ? newItem : item)) : []
}
